<template>
  <div>
    <h6 class="heading-small text-muted mb-4">{{ title }}</h6>
    <a-spin :spinning="formLoading">
      <table class="table table-striped">
        <thead class="thead">
          <tr>
            <th v-if="dataIndex != null" scope="col"><b>Key</b></th>
            <th v-for="column in columns" :key="column">
              <b>{{ column }}</b>
            </th>
          </tr>
        </thead>
        <draggable
          v-model="newDataSet"
          ghost-class="ghost"
          @start="drag = true"
          @end="drag = false"
          tag="tbody"
        >
          <tr v-for="(data, index) in newDataSet" :key="index">
            <td v-if="dataIndex != null" scope="row">{{ data[dataIndex] }}</td>
            <td v-for="column in columns" :key="column">
              {{ data[column] }}
            </td>
          </tr>
        </draggable>
      </table>
      <br />
      <br />
      <br />
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col text-left">
              <b-button
                v-if="!viewMode"
                size="sm"
                variant="primary"
                class="align-self-end"
                @click.prevent="reorderData"
              >
                Save
              </b-button>
            </div>
            <div class="col text-right">
              <b-button
                size="sm"
                variant="danger"
                class="align-self-end"
                @click.prevent="closeDrawer"
              >
                Cancel
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'ReorderForm',
  components: {
    draggable
  },
  props: {
    title: {
      default: 'Reorder Records',
      type: String
    },
    dataSet: {
      default: () => {
        return [];
      },
      type: Array
    },
    columns: {
      default: () => {
        return [];
      },
      type: Array
    },
    dataIndex: {
      default: null,
      type: String
    },
    viewMode: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      formLoading: true,
      newDataSet: []
    };
  },
  computed: {
    dataSets() {
      return [...this.dataSet];
    }
  },
  methods: {
    resetData() {
      this.newDataSet = [];
    },
    closeDrawer() {
      // this.resetData();
      this.$emit('closeDrawer', null);
    },
    reorderData() {
      const origData = this.newDataSet;
      let newData = [];
      if (this.dataIndex != null) {
        let x = 0;
        while (x < origData.length) {
          origData[x][this.dataIndex] = x + 1;
          newData.push(origData[x]);
          x++;
        }
      } else {
        newData = origData;
      }

      this.newDataSet = newData;
      this.$emit('updateOrder', newData);
      this.closeDrawer();
    }
  },
  created() {
    this.newDataSet = this.dataSets;
    this.formLoading = false;
  },
  mounted() {
    this.newDataSet = this.dataSets;
  }
};
</script>

<style scoped>
table,
td,
th {
  border: 1px solid #ddd;
  text-align: left;
}
</style>
